angular.module( 'acme.view.application.sherpa.activities.customer', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.sherpa.activities.customer.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var sherpaActivitiesCustomer = {
        name: 'application.sherpa.activities.customer',
        url: '/customer',
        views: {
          "subview-main": {
            controller: 'SherpaActivitiesCustomerController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/sherpa/activities/customer/customer.tpl.html'
          }
        },
        data: {
          pageTitle: 'CSR Activities'
        }
      };

    $stateProvider
      .state(sherpaActivitiesCustomer);
});
